export enum FieldMaxLength {
  LoginPageMessage = 1000,
  LoginPageDisclaimer = 5000,
  LoginPageErrorMessage = 500,
  LobbySupplementaryInfo = 5000,
  LobbyDescription = 5000,
  EmailRegistrationMessage = 1000,
}
